import Controller from "./invoiceItems.controller";
import template from "./invoiceItems.html";

const invoices = {
  template,
  controller: Controller,
};

export default invoices;



// WEBPACK FOOTER //
// ./src/pages/invoiceItems/invoiceItems.component.js